import { getLocale } from '@/paraglide/runtime';

const SIGNUP_LANGUAGE_COOKIE_NAME = 'listening_signup_language';

function buildSignupLanguageCookie() {
  const locale = getLocale() === 'es' ? 'es' : 'en';
  return [
    `${SIGNUP_LANGUAGE_COOKIE_NAME}=${encodeURIComponent(locale)}`,
    'Path=/',
    'Max-Age=600',
    'SameSite=Lax',
  ].join('; ');
}

export function persistSignupLanguageCookie() {
  if (typeof document === 'undefined') return;
  Reflect.set(document, 'cookie', buildSignupLanguageCookie());
}
